/**
 * Authentication API calls
 */

import apiClient, { setToken, clearAuth } from './client';
import { LoginRequest, LoginResponse, User } from '@/types/api';

/**
 * Login user with username and password
 */
export const login = async (credentials: LoginRequest): Promise<LoginResponse> => {
  const response = await apiClient.post<LoginResponse>('/auth/login', {
    username: credentials.username,
    password: credentials.password,
  });

  // Store token in localStorage
  if (response.data.access_token) {
    setToken(response.data.access_token);
  }

  return response.data;
};

/**
 * Get current user profile
 */
export const getCurrentUser = async (): Promise<User> => {
  const response = await apiClient.get<User>('/auth/me');

  // Store user data in localStorage
  localStorage.setItem('user', JSON.stringify(response.data));

  return response.data;
};

/**
 * Logout user - clear local storage
 */
export const logout = (): void => {
  clearAuth();
};

/**
 * Check if user session is valid
 */
export const validateSession = async (): Promise<boolean> => {
  try {
    await getCurrentUser();
    return true;
  } catch (error) {
    clearAuth();
    return false;
  }
};
